module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Kitchen-scale-3d527183b6b7241b42a68e71cbd67392.svg";